import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

export default [
  '$window', '$rootScope', '$location',
  function RegisterModalDirective($window, $rootScope, $location) {
    return {
      restrict: 'E',
      template: require('./register-modal.jade')(jadeLocals),
      scope: {
        redirecting: '='
      },
      link: (scope) => {
        scope.toggleLogin = () => {
          scope.toggle = false;
          $rootScope.$broadcast('login:open', {});
        }

        scope.$on('register:open', (event, { cancelRedirect = null }) => {
          scope.toggle = true;
          scope.cancelRedirect = cancelRedirect;

          if ($location.path() === '/register' && $location.search().signup_email)
            scope.$broadcast('register:signUpEmail', { email: $location.search().signup_email });

          _.delay(() => angular.element(document.querySelector('input[name="name"]')).focus(), 100);
        });

        scope.$on('register:close', (event, args) => {
          scope.toggle = false;
        });

        scope.$on('cui-modal-close', () => {
          if (scope.cancelRedirect) $window.location.href = scope.cancelRedirect;
        });
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/account/register/register-modal.dir.js